import { ActionIcon, Loader } from '@mantine/core'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'

export default function PaginationFooter({ count, page = 1, setPage, perPage = 100, isLoading }) {
    const totalPages = Math.max(1, Math.ceil((count ?? 0) / (Number(perPage) || 100)))
    const currentPage = Number(page) || 1

    return (
        <div className="flex flex-wrap items-center justify-between gap-3 border-t bg-white px-5 py-3 text-sm text-gray-500">
            <span className="flex items-center gap-2" aria-live="polite">
                {count == null ? 'Chargement…' : `${new Intl.NumberFormat('fr').format(count)} élément${count === 1 ? '' : 's'}`}
                {isLoading && <Loader size={12} color="gray" />}
            </span>
            <nav aria-label="Pagination" className="ml-auto flex shrink-0 items-center gap-3">
                <span className="whitespace-nowrap tabular-nums">Page {currentPage} sur {totalPages}</span>
                <div className="flex gap-2">
                    <ActionIcon type="button" variant="default" size={44} aria-label="Page précédente" disabled={isLoading || currentPage <= 1} onClick={() => setPage(currentPage - 1)}>
                        <IconChevronLeft size={20} />
                    </ActionIcon>
                    <ActionIcon type="button" variant="default" size={44} aria-label="Page suivante" disabled={isLoading || count == null || currentPage >= totalPages} onClick={() => setPage(currentPage + 1)}>
                        <IconChevronRight size={20} />
                    </ActionIcon>
                </div>
            </nav>
        </div>
    )
}
